<mat-card class="mat-card">
	<mat-toolbar color="primary">Meu Títulos</mat-toolbar>
	<mat-card-content>
		<form [formGroup]="formPesquisa" class="search-form">
			<div class="form-row">
				<mat-form-field class="flex-item">
				  <mat-label>Tipo</mat-label>
				  <mat-select [(ngModel)]="tipoSelecionado" formControlName="tipo">
					@for (tipo of tipos; track $index) {
					<mat-option class="mat-options" [value]="tipo.value">
					  {{ tipo.label }}
					</mat-option>
					}
				  </mat-select>
				</mat-form-field>
				<mat-form-field class="flex-item">
					<mat-label>Data inicial</mat-label>
					<input matInput [matDatepicker]="dataInicial" formControlName="dataInicial" />
					<mat-datepicker-toggle matSuffix [for]="dataInicial"></mat-datepicker-toggle>
					<mat-datepicker class="mat-calendar" #dataInicial></mat-datepicker>
					@if (formPesquisa.get('dataInicial').invalid) {
					<mat-error>Data inválida</mat-error>
					}
				</mat-form-field>
				<mat-form-field class="flex-item">
					<mat-label>Data final</mat-label>
					<input matInput [matDatepicker]="dataFinal" formControlName="dataFinal" />
					<mat-datepicker-toggle matSuffix [for]="dataFinal"></mat-datepicker-toggle>
					<mat-datepicker #dataFinal></mat-datepicker>
					@if (formPesquisa.get('dataFinal').invalid) {
					<mat-error>Data inválida</mat-error>
					}
				</mat-form-field>
				<mat-checkbox class="margin-top-8" color="primary" [(ngModel)]="isCredito" formControlName="isCredito">
					Crédito
				</mat-checkbox>
				<button
					mat-raised-button
					color="primary"
					(click)="getTitulosComFiltro()"
					[disabled]="formPesquisa.invalid"
					class="flex-item custom-button"
					>
					OK
				</button>
			</div>
		</form>
		<div>
			<div class="alinhar-itens">
				@if (isPesquisando) {
				<mat-spinner class="spinner-align" mode="indeterminate">
				</mat-spinner>
				}
			</div>
			@if (!isPesquisando && listaTitulos.length <= 0) {
			<div class="container"> Títulos não encontrados :( </div>
			}
			<div class="scrollBar">
				@if (!isPesquisando && listaTitulos.length > 0) {
				<table class="tabela tabela-responsive">
					<thead>
						<tr>
							<th>Nr. Documento</th>
							<th>Parcela(s)</th>
							<th>Dt. Vencimento</th>
							<th>Cond. de pagamento</th>
							<th>Saldo</th>
							<th>Valor Nominal</th>
							<th>Forma de pagamento</th>
							<th>Status</th>
							<th>Boleto</th>
						</tr>
					</thead>
					<tbody>
						@for (titulo of listaTitulos; track $index) {
						<tr>
							<td>{{titulo.nrDocumento}}</td>
							<td>{{titulo.parcela}}</td>
							<td>{{titulo.dtVcto}}</td>
							<td>{{titulo.nmCondPgto}}</td>
							<td>{{titulo.vlSaldo.toFixed(2) | currency:'R$':'code'}}</td>
							<td>{{titulo.vlNominal.toFixed(2) | currency:'R$':'code'}}</td>
							<td>{{titulo.nmFormaPgto}}</td>
							@if (calculaStatus(titulo.vlSaldo, titulo.dtVcto)==='QUITADO') {
							<td><mat-icon [matTooltip]="'Quitado'" style="color:#3a8346">check_circle_outline</mat-icon></td>
							}
							@if (calculaStatus(titulo.vlSaldo,titulo.dtVcto)==='VENCENDO') {
							<td><mat-icon [matTooltip]="'Vencendo'" style="color:#e4cf12">error_outline</mat-icon></td>
							}
							@if (calculaStatus(titulo.vlSaldo,titulo.dtVcto)==='VENCIDO') {
							<td><mat-icon [matTooltip]="'Vencido'" style="color:#be2d2d">error_outline</mat-icon></td>
							}
							@if (calculaStatus(titulo.vlSaldo,titulo.dtVcto)==='PENDENTE') {
							<td><mat-icon [matTooltip]="'Pendente'" style="color:gray">error_outline</mat-icon></td>
							}
							<td>
								<div class="flex-row">
									@if (titulo.temPdf) {
									<div class="table-button">
										<button mat-raised-button color="primary" (click)="getBoleto(titulo.idCprParcela)">Boleto <mat-icon>file_download</mat-icon></button>
									</div>
									}
								</div>
							</td>
						</tr>
						}
					</tbody>
				</table>
				}
			</div>
		</div>
	</mat-card-content>
</mat-card>
